import React from 'react';

import { Tab, Tabs } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core';

import { Container, TabsHeader } from './styles';
import TabPanel from './TabPanel';

export interface ITab {
  label: string;
  value: number;
  content: React.ReactNode;
  disabled?: boolean;
}

export interface TabPanelProps {
  ariaLabel: string;
  onChange: (newValue: number) => void;
  options: ITab[];
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    height: '100%',
  },
}));

const TabsContainer: React.FC<TabPanelProps> = ({
  ariaLabel,
  onChange,
  options,
  value,
}) => {
  const classes = useStyles();

  const handleChange = (_: React.ChangeEvent<unknown>, newValue: number) => {
    onChange(newValue);
  };

  return (
    <Container className={classes.root}>
      <TabsHeader>
        <Tabs value={value} onChange={handleChange} aria-label={ariaLabel}>
          {options.map((option) => (
            <Tab
              disabled={option.disabled}
              key={option.value}
              label={option.label}
              {...a11yProps(option.value)}
            />
          ))}
        </Tabs>
      </TabsHeader>

      {options.map((option) => (
        <TabPanel key={option.value} value={value} index={option.value}>
          {option.content}
        </TabPanel>
      ))}
    </Container>
  );
};

export default TabsContainer;
